export default __webpack_public_path__ + "static/media/clicked.e8fac447.svg";